import { Button, Grid, Stack, Step, StepButton, Stepper } from "@mui/material";
import { useContext, useState } from "react";
import CreatePollStep from "../components/CreatePollStep";
import ManagePollStep from "../components/ManagePollStep";
import CreatePostStep from "../components/CreatePostStep";
import { CreatePollContext } from "../context/CreatePollContextProvider";
import VideoChatIcon from '@mui/icons-material/VideoChat';
import API from "../api/Api";
import { UserContext } from "../context/UserContextProvider";
import { useNavigate } from "react-router-dom";
import ConfirmTransactionDialog from "../components/ConfirmTransactionDialog";
import { TangledContext } from "../context/TangledContextProvider";

const CreatePollPage = () => {
    const navigate = useNavigate();
    const tangled = useContext(TangledContext);
    const createPollFeeMlx = 10000;
    const [activeStep, setActiveStep] = useState(0);
    const [showTransactionConfirmDialog, setShowTransactionConfirmDialog] = useState(false);
    const { pollId, pollQuestion, pollOptions, imgFile, setPollId, groupsCanVote,
        hasVoteFee, isValidVoteFee, voteFee, hasExpireDate, isValidExpireDate, expireDate } = useContext(CreatePollContext)
    const { user } = useContext(UserContext);

    const steps = ['Configure poll', 'Create post', 'Manage poll'];

    const createOrUpdatePoll = async () => {
        setShowTransactionConfirmDialog(false);
        try {
            if (activeStep === 0 && !pollId) {
                const response = await tangled.current.requestPayment(
                    createPollFeeMlx.toLocaleString('en-US'),
                    0,
                    `Pay ${createPollFeeMlx.toLocaleString('en-US')} to create the poll "${pollQuestion}".`,
                );

                if (response.status === 'fail') {
                    return
                }

                //create
                const data = await API.createPoll({
                    question: pollQuestion, options: pollOptions, tangledIdemGUID: user.idem_guid, tangledUserName: user.user_name_formatted, tangledLedgerGUID: response.ledger_guid_application_deposit,
                    // @ts-ignore
                    voteFee: hasVoteFee ? parseInt(voteFee.replaceAll(',', '')) : undefined, expireDate: hasExpireDate ? expireDate : undefined, blockTangledGroups: !groupsCanVote
                }, imgFile)
                setPollId(data._id);
            } else {
                //update
                await API.updatePoll(pollId, {
                    question: pollQuestion, options: pollOptions, tangledIdemGUID: user.idem_guid, tangledUserName: user.user_name_formatted,
                    // @ts-ignore
                    voteFee: hasVoteFee ? parseInt(voteFee.replaceAll(',', '')) : null, expireDate: hasExpireDate ? expireDate : null, blockTangledGroups: !groupsCanVote
                }, imgFile)
            }
            setActiveStep(activeStep + 1)
        } catch (e) {
            console.error(e)
        }
    }

    const goToNextStep = () => {
        setActiveStep(activeStep + 1)
    }
    const goToPreviousStep = () => {
        setActiveStep(activeStep - 1)
    }

    return <Grid container spacing={2}>
        <Grid item xs={12}>
            <Stepper nonLinear activeStep={activeStep}>
                {steps.map((label, index) => (
                    <Step key={label} completed={activeStep > index}>
                        <StepButton disabled>
                            {label}
                        </StepButton>
                    </Step>
                ))}
            </Stepper>
        </Grid>
        <CreatePollStep step={0} activeStep={activeStep} />
        <CreatePostStep step={1} activeStep={activeStep} />
        <ManagePollStep step={2} activeStep={activeStep} />
        <Grid item xs={12} justifyContent={'center'} display={'flex'}>
            <Stack direction={"row"} spacing={2}>
                {activeStep > 0 && activeStep < 2 && <Button variant='outlined' sx={{ minWidth: 200 }} onClick={goToPreviousStep}>Previous</Button>}
                {activeStep === 0 && <Button variant='contained' sx={{ minWidth: 200 }} onClick={() => pollId ? createOrUpdatePoll() : setShowTransactionConfirmDialog(true)} disabled={!pollQuestion || pollOptions.length < 2 || hasVoteFee && !isValidVoteFee || hasExpireDate && !isValidExpireDate}>{pollId ? 'Update' : 'Create'}</Button>}
                {activeStep === 1 && <Button startIcon={<VideoChatIcon />} variant="outlined" href={`https://tangled.com/content_edit.php?application_instance_url=${encodeURIComponent(`/a/E9xRK6Dw7HfU4zktPsD68794ZgmTuuz8#/view/${pollId}`)}`} target="_blank" sx={{ minWidth: 200 }} onClick={goToNextStep}>Create Post</Button>}
                {activeStep === 2 && <Button variant='contained' sx={{ minWidth: 200 }} onClick={() => navigate(`/poll/${pollId}`)}>Manage Poll</Button>}
            </Stack>
        </Grid>
        {activeStep === 1 && <Grid item xs={12} justifyContent={'center'} display={'flex'} mb={4}>
            <Button variant={'text'} sx={{ minWidth: 200 }} onClick={() => goToNextStep()}>I will post later</Button>
        </Grid>}
        {showTransactionConfirmDialog && (
            <ConfirmTransactionDialog
                handleCancel={() => setShowTransactionConfirmDialog(false)}
                handleConfirm={createOrUpdatePoll}
                mlxAmount={createPollFeeMlx}
                open={true}
            ></ConfirmTransactionDialog>
        )}
    </Grid>
}

export default CreatePollPage;